import { ReactComponent as IconEyeOpen } from '@/assets/svgs/eye.svg';
import { ReactComponent as IconEyeClose } from '@/assets/svgs/password-eye.svg';

const IconEye = ({ bool }) => {

	return (
		<>
			{bool ? <IconEyeClose/> : <IconEyeOpen/> }
		</>
	)
}

export default IconEye
